import { AxiosResponse } from 'axios';

import { EditInspectionRequestType, FetchInspectionsRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { InspectionStatus } from 'enums';
import { InspectionType } from 'state';
import {
  CreateInspectionResponseType,
  PendingInspectionResponseType,
} from 'state/reducers/inspections/types';

export const fetchInspectionsRequest = (params: FetchInspectionsRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<InspectionType>,
    AxiosResponse<GeneralResponseType<InspectionType>>,
    FetchInspectionsRequestType
  >(`/inspection`, { params });
};

export const fetchCertainInspectionRequest = (
  id: string,
  loadFoundProperties?: boolean,
  silent?: boolean,
) => {
  return authServiceClient.get<InspectionType, AxiosResponse<InspectionType>, string>(
    `/inspection/${id}`,
    { params: { loadFoundProperties }, silentError: silent },
  );
};

export const createInspectionRequest = () => {
  return authServiceClient.post<
    CreateInspectionResponseType,
    AxiosResponse<CreateInspectionResponseType>
  >(`/inspection`);
};
export const fetchPendingInspectionsRequest = () => {
  return authServiceClient.get<
    PendingInspectionResponseType[],
    AxiosResponse<PendingInspectionResponseType[]>
  >(`/inspection/pending`);
};

export const editInspectionRequest = ({
  propertyId,
  communityId,
  status,
  id,
  name,
  ignoreWarnings,
  fullReprocess,
}: EditInspectionRequestType & { id: string; fullReprocess: boolean }) => {
  const data: EditInspectionRequestType & {
    createdAt?: number;
    fullReprocess?: boolean;
  } = {
    propertyId,
    communityId,
    status,
    name,
    ignoreWarnings,
    fullReprocess,
  };

  if (status === InspectionStatus.CREATING) {
    data.createdAt = Date.now();
  }

  return authServiceClient.put<InspectionType, AxiosResponse<CommonResponseType>, string>(
    `/inspection/${id}`,
    JSON.stringify(data),
  );
};

export const editNameInspectionRequest = ({ name, id }: { name: string; id: string }) => {
  return authServiceClient.patch<
    InspectionType,
    AxiosResponse<InspectionType>,
    { name: string }
  >(`/inspection/${id}/rename`, { name });
};

export const deleteInspectionRequest = (id: string, confirm: boolean) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/inspection/${id}/${confirm}`,
  );
};
